import { Vue, Component } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import { WHITE_LABELING_SETTINGS_KEYS_MAPPING } from '@/utils/constants';
import WhiteLabelingSettings from '../white-labeling/white-labeling-settings/white-labeling-settings';
import { tenantSettingsAPI } from '@/providers/apis/tenant-settings/tenant-settings';
import FormLoader from '../form-loader/form-loader';

@Component({
    name: 'white-labeling',
    components: {
        'material-icons': GoogleMaterialIcon,
        'white-labeling-settings': WhiteLabelingSettings,
        'form-loader': FormLoader,
    },
})

export default class WhiteLabeling extends Vue {


    private tenantSettings: any = [];

    private tenantkeyDefinition: any = WHITE_LABELING_SETTINGS_KEYS_MAPPING;

    private selectedConfig: any = null;

    private activeComponent: string = 'tx-loader';
    private categoryList: any = [];

    private created() {
        this.getAllListAPICall();
        this.$store.dispatch('tenantStore/fetchTenantSettings').then(() => {
           this.tenantSettings = this.$store.state.tenantStore.tenantSettings;
           this.onSelectSettings(this.tenantkeyDefinition.translation_setting, 'translation_setting');
        });
    }


    // -------------------------------------------------------------------------------
    // Actions

    private getAllListAPICall() {
        this.categoryList = this.$store.state.categorySubjectStore.categoryLists;
        if (this.categoryList && this.categoryList.length === 0) {
            this.getCategoryList();
        }
    }

    private getCategoryList() {
        this.$store.dispatch('categorySubjectStore/fetchCategoryList');
    }


    private onSelectSettings(setting: any, value: string) {
        setting.tenantKey = value;
        this.activeComponent = setting.key;
        const existingKey = this.tenantSettings.find((item: any) => item.key === value) || {};
        setting.tenantConfig = existingKey;
        this.selectedConfig = setting;
    }

    private onChangeConfig(config: any) {
        const payload = {
            tenant_key: this.selectedConfig.tenantKey,
            value: (typeof config === 'object' ? JSON.stringify(config) : config),
        };
    }

    // --------------------------------------------------------------------------------
    // Methods

    private updateConfig(config: any) {
        tenantSettingsAPI.updateTenantSettings(config).then(() => {
            this.$store.dispatch('tenantStore/fetchTenantSettings').then(() => {
                this.tenantSettings = this.$store.state.tenantStore.tenantSettings;
             });
        });
    }

    private diabledItem(item: any) {
        if (item.key === 'nav-class-setup' || item.key === 'cm-completion-score') {
            const framworkData = this.tenantSettings.find((setting: any) => setting.key === 'tx_fw_prefs');
            return framworkData ? false : true;
        }
    }


}
